module.exports = __webpack_public_path__ + "static/phone4-a6521b890d1ada660673dbdf06f59402.png";